
import { get, post, patch, destroy } from "@/lib/fetcher";

export async function getJobs(params = {}) {
    return await get("/admin/jobs", params);
}

export async function getJob(id) {
    return await get(`/admin/jobs/${id}`);
}

export async function postJob(data) {
    return await post("/admin/jobs", data);
}

export async function postAssignCandidate(id,data){
    return await post(`/admin/jobs/${id}/assign_candidate`, data)
}

export async function postUnassignCandidate(id,data){
    return await post(`/admin/jobs/${id}/unassign_candidate`)
}

export async function postAcceptCandidate(id){
    return await post(`/admin/jobs/${id}/accept`)
}

export async function patchJob(id, data) {
    return await patch(`/admin/jobs/`,id, data);
}

export async function deleteJob(id) {
    return await destroy(`/admin/jobs/${id}`);
}
